var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgStepByStep = function SvgStepByStep(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44.867,
    height: 45.65,
    viewBox: "0 0 44.867 45.65",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#4a7aff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(3.242 -8.001) rotate(30)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(16.003)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M45.1,8.016a2.993,2.993,0,0,0-1,.172V5.01A3,3,0,0,0,39.98,2.216a3.006,3.006,0,0,0-5.8,0,3,3,0,0,0-4.107,2.794c0,.035,0,1.346,0,3.178a3.014,3.014,0,0,0-3.907,2.044,3.006,3.006,0,0,0-4.113,2.795c0,.077,0,6.456.006,10.851l-.886-.886a3.006,3.006,0,0,0-4.553,3.9l3.389,5.25q.019.03.04.058a5.034,5.034,0,0,0,4.008,2H35.076a5.016,5.016,0,0,0,5.01-5.01V26.119h3.006a5.016,5.016,0,0,0,5.01-5.01V11.022A3.009,3.009,0,0,0,45.1,8.016ZM32.07,5.01a1,1,0,0,1,2,0v5.182a3,3,0,0,0-2.008,0C32.068,7.388,32.07,5.057,32.07,5.01Zm6.012,24.181A3.009,3.009,0,0,1,35.076,32.2H24.055a3.021,3.021,0,0,1-2.385-1.176c-3.589-5.559-3.393-5.259-3.426-5.3a1,1,0,0,1,1.51-1.31l2.6,2.6a1,1,0,0,0,1.093.217.99.99,0,0,0,.6-.928c-.01-3.87,0-13.179,0-13.272a1.005,1.005,0,0,1,2.011,0v8.083a1,1,0,0,0,2,0V11.022a1.007,1.007,0,0,1,2.011-.078c0,6.51,0,4.809,0,10.164a1,1,0,1,0,2,0V13.026a1,1,0,0,1,2,0v8.083a1,1,0,1,0,2,0v-2a1,1,0,1,1,2,0ZM46.1,21.109a3.009,3.009,0,0,1-3.006,3.006H40.086V19.1a3.007,3.007,0,0,0-4.008-2.834V3.006a1,1,0,0,1,2,0v10.02a1,1,0,0,0,2,0V5.01a1,1,0,0,1,2,0v8.016a1,1,0,0,0,2,0v-2a1,1,0,0,1,2,0Z",
    transform: "translate(-16.041)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(16 0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M21.719,4.3,17.711.294a1,1,0,0,0-1.417,1.417L20.3,5.719A1,1,0,0,0,21.719,4.3Z",
    transform: "translate(-16.001 0)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(24.016)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M137,0a1,1,0,0,0-1,1V5.01a1,1,0,1,0,2,0V1A1,1,0,0,0,137,0Z",
    transform: "translate(-136)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(16 8.016)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M21.01,120H17a1,1,0,0,0,0,2H21.01a1,1,0,1,0,0-2Z",
    transform: "translate(-16 -120)"
  }))))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgStepByStep, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "fonts/step_by_step.svg";
export { ForwardRef as ReactComponent };